import { useSelector } from 'react-redux';

import { useBalanceRemainingForCreditCard } from 'checkout/utils/hooks';
import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const TotalRemaining = () => {
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { currency } = settings;

  const balance = useBalanceRemainingForCreditCard();

  if (balance <= 0) {
    return null;
  }

  return (
    <div className="c7-order-summary__item--total">
      <div className="c7-order-summary__title">
        {t('checkout.general.totalRemaining')}
      </div>
      <div className="c7-order-summary__value">
        <span>{currency}</span> {currencyFormat(balance, currency)}
      </div>
    </div>
  );
};

export default TotalRemaining;
